import { Component } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[sui-mini-button]',
  templateUrl: './mini-button.component.html',
  styleUrl: './mini-button.component.scss',
})
export class MiniButtonComponent {}
